// ======================================================================
// File Name       : AuthorityConstant
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const MANAGEMENT_AUTHORITY_TYPE = {
  NOT_USED: 0,
  REFERENCE: 1,
  REFERENCE_REGISTRATION_EDIT: 2,
};

export const SCORING_MANAGEMENT_AUTHORITY_TYPE = {
  NOT_USED: 0,
  SCORING: 1,
  SCORING_APPROVAL: 2,
};

export const GUIDELINE_AUTHORITY = { authority_register: 'AuthorityRegister.html' };

export const AUTHORITY_PRESET_DEFAULT = {
  DEFAULT: 0,
  ADMIN: 1,
  TEACHER: 2,
  SCORER: 3,
};

export const USER_AUTHORITY_ROLE = {
  ADMIN: 'admin_role',
  TEACHER: 'teacher_role',
  SCORING_MANAGEMENT: 'scoring_management_role',
  HISTORY_VIEWING: 'history_viewing_role', // Step 10.0.0
};

export const LIVE_MANAGEMENT_AUTHORITY_TYPE = {
  NOT_USED: 0,
  REFERENCE_REGISTRATION_EDIT: 2,
};

export const IS_SHOW_LIVE_TAB = 'isShowLiveTab';

// Step 10.0.0 START
export const MANAGEMENT_AUTHORITY_DISPLAY_TYPE = {
  HIDE: 0,
  DISPLAY: 1,
};

export const SUPERUSER_ENTERPRISE_AUTHORITY_PRESET_DEFAULT = {
  DEFAULT: 0,
  ADMIN: 1,
  READ_ONLY_ADMIN: 2,
};

export const SUPERUSER_ENTERPRISE_ROLE = {
  ADMIN: 'admin_role',
  READ_ONLY_ADMIN: 'readonly_admin_role',
  SERVICE_ADMIN: 'service_admin_role', // Step 11.0.0
};

// Step 10.0.0 END
